import { For, JSXElement, Match, mergeProps, Show, Switch } from 'solid-js';
import { getTranslationKey } from './utils';
import { getLocalizedString } from '~/i18n/utils';
import { Localized } from '~/i18n';
import { Tag } from '~/components/ui/Tag';
import { ApplicationTypeEnum } from '~/api';

type ApplicationTypeContentProps = {
  type: ApplicationTypeEnum;
  showDescription?: boolean;
  showTagList?: boolean;
};

export default function ApplicationTypeContent(
  props: ApplicationTypeContentProps
) {
  const mergedProps = mergeProps(
    { showDescription: true, showTagList: true },
    props
  );

  return (
    <div>
      <Switch>
        <Match when={mergedProps.type === ApplicationTypeEnum.WEB_APPLICATION}>
          <IndividualApplicationContent
            applicationName={getLocalizedString(
              getTranslationKey('web_application')
            )}
            description={getLocalizedString(
              getTranslationKey('web_application_description')
            )}
            tagsList={['tag_confidential_client']}
            showDescription={mergedProps?.showDescription}
            showTagList={mergedProps?.showTagList}
          />
        </Match>
        <Match
          when={
            mergedProps.type === ApplicationTypeEnum.SINGLE_PAGE_APPLICATION
          }
        >
          <IndividualApplicationContent
            applicationName={getLocalizedString(
              getTranslationKey('single_page_application')
            )}
            description={getLocalizedString(
              getTranslationKey('single_page_application_description')
            )}
            tagsList={['tag_pkce_enforced', 'tag_public_client']}
            showDescription={mergedProps?.showDescription}
            showTagList={mergedProps?.showTagList}
          />
        </Match>
        <Match
          when={mergedProps.type === ApplicationTypeEnum.NATIVE_APPLICATION}
        >
          <IndividualApplicationContent
            applicationName={getLocalizedString(
              getTranslationKey('native_application')
            )}
            description={getLocalizedString(
              getTranslationKey('native_application_description')
            )}
            tagsList={['tag_pkce_enforced', 'tag_public_client']}
            showDescription={mergedProps?.showDescription}
            showTagList={mergedProps?.showTagList}
          />
        </Match>
      </Switch>
    </div>
  );
}

type IndividualApplicationContentProps = {
  applicationName: JSXElement;
  description?: JSXElement;
  tagsList?: Array<string>;
  showDescription?: boolean;
  showTagList?: boolean;
};

const IndividualApplicationContent = (
  props: IndividualApplicationContentProps
) => {
  return (
    <div class="flex flex-col gap-2">
      <div class="fg-subtle text-sm font-normal">{props.applicationName}</div>
      <Show when={props.showDescription || props.showTagList}>
        <div class="flex flex-col gap-2">
          {props.showDescription && (
            <div class="text-xs">{props.description}</div>
          )}
          {props.showTagList && (
            <div class="flex gap-2">
              <For each={props.tagsList}>
                {(tag) => {
                  return (
                    <Tag
                      variant="secondary"
                      class="m-0"
                    >
                      <Localized translationKey={getTranslationKey(tag)} />
                    </Tag>
                  );
                }}
              </For>
            </div>
          )}
        </div>
      </Show>
    </div>
  );
};
